import { render, staticRenderFns } from "./ListCommunicationMatter.vue?vue&type=template&id=a150179e"
import script from "./ListCommunicationMatter.vue?vue&type=script&lang=js"
export * from "./ListCommunicationMatter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports